import React from 'react';
import styled from 'styled-components';

import OrderInvoice from 'components/containers/commerce/order/OrderInvoice';

import TitleHeader from 'components/presenters/header/TitleHeader';

export default function OrderInvoiceLayout({ orderNo }) {
  
  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader title={"주문내역"} hideBtn/>
      </HeaderBlock>
      <Content>
        <OrderInvoice orderNo={orderNo} />
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  padding-bottom: calc(100vw * (130 / 375));
  overflow-y: scroll;
`;